import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import EzHeading from "../EzHeading/EzHeading.es.js";
import EzLayout from "../EzLayout/EzLayout.es.js";
import { SuccessIcon, InfoIcon, ErrorIcon } from "../Icons/index.es.js";
import stitches from "../theme.config.es.js";
import CloseButton from "../utils/CloseButton/CloseButton.es.js";
import { useId } from "@radix-ui/react-id";
const flashMessage = stitches.css({
  borderStyle: "$flash-message-border-style",
  borderWidth: "$flash-message-border-width",
  borderLeftWidth: "$flash-message-border-left-width",
  fontFamily: "$defaultFont",
  padding: "$flash-message-p",
  "@medium": {
    borderRadius: "$flash-message-rounded"
  },
  variants: {
    use: {
      success: {
        backgroundColor: "$flash-message-bg-success",
        borderColor: "$flash-message-border-success",
        borderLeftColor: "$flash-message-accent-success",
        boxShadow: "$flash-message-box-shadow-success",
        "svg path": {
          fill: "$flash-message-accent-success"
        }
      },
      error: {
        backgroundColor: "$flash-message-bg-error",
        borderColor: "$flash-message-border-error",
        borderLeftColor: "$flash-message-accent-error",
        boxShadow: "$flash-message-box-shadow-error",
        "svg path": {
          fill: "$flash-message-accent-error"
        }
      },
      warning: {
        backgroundColor: "$flash-message-bg-warning",
        borderColor: "$flash-message-border-warning",
        borderLeftColor: "$flash-message-accent-warning",
        boxShadow: "$flash-message-box-shadow-warning",
        "svg path": {
          fill: "$flash-message-accent-warning"
        }
      },
      info: {
        backgroundColor: "$flash-message-bg-info",
        borderColor: "$flash-message-border-info",
        borderLeftColor: "$flash-message-accent-info",
        boxShadow: "$flash-message-box-shadow-info",
        "svg path": {
          fill: "$flash-message-accent-info"
        }
      }
    }
  }
});
const text = stitches.css({ "&&": { flex: 1 } });
const buttonAlignment = stitches.css({
  alignSelf: "start"
});
const icons = {
  error: /* @__PURE__ */ jsx(ErrorIcon, {}),
  warning: /* @__PURE__ */ jsx(ErrorIcon, {}),
  info: /* @__PURE__ */ jsx(InfoIcon, {}),
  success: /* @__PURE__ */ jsx(SuccessIcon, {})
};
const EzFlashMessage = ({
  autohide,
  autohideDuration,
  children,
  headline,
  onAutohide,
  onDismiss,
  use
}) => {
  const labelId = useId();
  const [show, setShow] = useState(true);
  useEffect(() => {
    if (!autohide) return void 0;
    const autohideTimer = setTimeout(() => {
      if (onAutohide) onAutohide();
      setShow(false);
    }, autohideDuration || 5e3);
    return () => clearTimeout(autohideTimer);
  }, [autohide, onAutohide, autohideDuration]);
  if (!show) return null;
  const role = use === "info" ? "status" : "alert";
  return /* @__PURE__ */ jsx(
    "div",
    {
      role,
      "aria-labelledby": labelId,
      "aria-live": use === "error" ? "assertive" : "polite",
      className: flashMessage({ use }),
      children: /* @__PURE__ */ jsxs(EzLayout, { layout: "basic", alignY: "top", children: [
        icons[use],
        /* @__PURE__ */ jsx("div", { className: text(), children: /* @__PURE__ */ jsxs(EzLayout, { layout: "stack", children: [
          headline && /* @__PURE__ */ jsx(EzHeading, { id: labelId, size: "3", children: headline }),
          /* @__PURE__ */ jsx("div", { id: headline ? void 0 : labelId, children })
        ] }) }),
        onDismiss && /* @__PURE__ */ jsx("div", { className: buttonAlignment(), children: /* @__PURE__ */ jsx(CloseButton, { label: "Close", onClick: onDismiss }) })
      ] })
    }
  );
};
export {
  EzFlashMessage as default
};
//# sourceMappingURL=EzFlashMessage.es.js.map
